import React, { useState, useEffect } from 'react';
import Navbar from './NavBar';
import Footer from './Footer';

const Layout = ({ children }) => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > 300;
      setShowScrollTop(scrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="text-gray-800">
      <Navbar />
      <main>{children}</main>
      <Footer />
      {showScrollTop && (
        <a
          href="#home"
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-yellow-500 text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg hover:bg-yellow-600 transition duration-300 z-50"
        >
          <i className="fas fa-arrow-up text-white"></i>
        </a>
      )}
    </div>
  );
};

export default Layout;